import React from "react";

import { Typography as MuiTypography } from "@mui/material";
import clsx from "clsx";

import { colors } from "@/theme/overrides/colors";

import * as types from "./base/types";
import { useTypographyStyles } from "./base/useTypographyStyles";

export const SubheadBold: React.FC<types.TypographyProps> = ({
  text,
  ...props
}) => {
  const { classes } = useTypographyStyles();

  return (
    <MuiTypography
      className={clsx(classes.textBold, classes.subhead)}
      color={props.color ?? colors.mapped.text.subheading}
      {...props}
    >
      {text}
    </MuiTypography>
  );
};
